import { jsx } from "panel";
import { DropMenuEl } from "common/components/drop-menu";
import { InputEl } from "common/components/input";
import { ButtonBarEl } from "common/components/button-bar";
import { ButtonBarTheme } from "common/components/button-bar/types";
import { TargetProjectSelectorMenuEl } from "../target-project-selector-menu";
import { CreateProjectModalEl } from "../create-project-modal";
export function template() {
  const { searchFilter, isCreateProjectModalOpen } = this.state;
  return /* @__PURE__ */ jsx(DropMenuEl, {
    attrs: { open: true, direction: this.params.direction, offset: this.params.offset },
    props: { positionParent: this.params.positionParent },
    on: { change: this.helpers.handleMenuChange }
  }, /* @__PURE__ */ jsx("div", {
    sel: ".mp-project-selector-container"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".mp-project-selector-search-container"
  }, /* @__PURE__ */ jsx(InputEl, {
    attrs: {
      icon: `search`,
      placeholder: this.params.searchPlaceholder
    },
    on: { input: this.helpers.handleSearchInput },
    props: { value: searchFilter },
    hook: { insert: this.helpers.handleSearchInputInsertHook }
  })), /* @__PURE__ */ jsx(TargetProjectSelectorMenuEl, {
    params: {
      isFeatureGateEnterpriseTier: false,
      projectSearchFilter: searchFilter,
      fillWidth: true
    },
    on: {
      projectSelected: this.helpers.handleProjectSelected
    }
  }), /* @__PURE__ */ jsx(ButtonBarEl, {
    attrs: { theme: ButtonBarTheme.Secondary },
    on: { click: this.helpers.handleOpenProjectModal }
  }, this.params.submitCopy)), isCreateProjectModalOpen && /* @__PURE__ */ jsx(CreateProjectModalEl, {
    attrs: this.helpers.getCreateProjectModalAttrs(),
    on: { cancel: this.helpers.handleCancelProjectModal, create: this.helpers.handleCreateProjectModal }
  }));
}
